export type TasksFilterSegmentId =
  | 'all'
  | 'watch'
  | 'share'
  | 'action'
  | 'create'

export const TASKS_FILTER_SEGMENTS: readonly TasksFilterSegmentId[] = [
  'all',
  'watch',
  'share',
  'action',
  'create'
]
